function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { GridItem, MenuItem, Select, TextButton, TextField, WithInfoIcon } from 'seagull';
import { getCustomMessageValidation } from "../../../business-logic/validators";
import { useStoreActions } from "../../../store/store-context";
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import styles from "./IntroMessage.module.scss";
import { isCustomMessageType, orderedTemplateTypesForDropdown, templateTypeToDropdownLabel, useEditIntroMessage } from "./IntroMessage.utils";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const messageRules = getCustomMessageValidation('Introductory message', true);
export default function IntroMessage(props) {
  const {
    initialTemplateContent,
    disabled,
    onMessageChange,
    inputWidth = '512px'
  } = props;
  const {
    getTemplateTypeByMessage,
    templateTypeToContent
  } = useEditIntroMessage();
  const {
    logBI
  } = useStoreActions();
  const defaultValues = {
    type: getTemplateTypeByMessage(initialTemplateContent),
    message: initialTemplateContent
  };
  const [customMessage, setCustomMessage] = useState(isCustomMessageType(defaultValues.type) ? initialTemplateContent : '');
  const {
    control,
    setValue,
    getValues
  } = useForm({
    mode: 'all',
    defaultValues
  });
  const [showTemplateMessage, setShowTemplateMessage] = useState(false);
  const onTypeChange = newType => {
    logBI(10491, {
      templateType: newType
    });
    const newMessage = isCustomMessageType(newType) ? customMessage : templateTypeToContent[newType];
    if (isCustomMessageType(newType)) setShowTemplateMessage(true);
    setValues({
      newType,
      newMessage
    });
  };
  const onEditMessage = newMessage => {
    const newType = getTemplateTypeByMessage(newMessage);
    if (isCustomMessageType(newType)) setCustomMessage(newMessage);
    setValues({
      newType,
      newMessage
    });
  };
  const setValues = _ref => {
    let {
      newType,
      newMessage
    } = _ref;
    const [type, message] = getValues(['type', 'message']);
    if (newMessage !== type) {
      setValue('type', newType);
    }
    if (newMessage !== message) {
      onMessageChange(newMessage);
      setValue('message', newMessage);
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(GridItem, {
      span: 12,
      className: styles.firstRow,
      "data-testid": "intro-message",
      children: [/*#__PURE__*/_jsx(WithInfoIcon, {
        className: styles.inputContainer,
        info: "This message will show as an introductory message on the agreement and the email your client receives. You can configure the default messages in your business settings.",
        children: /*#__PURE__*/_jsx(Controller, {
          control: control,
          name: "type",
          render: renderProps => /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
            onChange: e => {
              onTypeChange(e.target.value);
              renderProps.field.onChange(e);
            },
            "data-testid": "template-type-dropdown",
            label: "Introductory message",
            disabled: disabled,
            style: {
              width: inputWidth
            },
            children: orderedTemplateTypesForDropdown.map(templateType => /*#__PURE__*/_jsx(MenuItem, {
              value: templateType,
              "data-testid": "template-type-".concat(templateType),
              children: templateTypeToDropdownLabel[templateType]
            }, templateType))
          }))
        })
      }), /*#__PURE__*/_jsx(TextButton, {
        "data-testid": "edit-message",
        disabled: disabled,
        onClick: () => {
          logBI(10490);
          setShowTemplateMessage(true);
        },
        style: {
          visibility: showTemplateMessage ? 'hidden' : 'visible'
        },
        children: "Edit message"
      })]
    }), showTemplateMessage && /*#__PURE__*/_jsx(GridItem, {
      span: 12,
      children: /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "message",
        rules: messageRules,
        render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
          onChange: e => {
            onEditMessage(e.target.value);
            renderProps.field.onChange(e);
          },
          "data-testid": "template-content",
          disabled: disabled,
          placeholder: "Your message\u2026",
          multiline: true,
          minRows: 9,
          maxRows: 9
        }))
      })
    })]
  });
}